import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

const TagFilter = ({ tags, selectedTags, onTagChange }) => {
  return (
    <Tooltip
      title={
        selectedTags.length > 0
          ? `${selectedTags.join(", ")}`
          : "Select tags to filter by"
      }
      placement="top"
      arrow
    >
      <FormControl
        sx={{
          m: 0.5,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          width: 120,
        }}
        size="small"
      >
        <Select
          multiple
          value={selectedTags}
          onChange={(e) => onTagChange(e.target.value || [])}
          displayEmpty
          renderValue={(selected) =>
            selected.length > 0 ? selected.join(", ") : <span>Tags</span>
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          input={
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <TuneIcon />
                </InputAdornment>
              }
            />
          }
        >
          {tags.map((tag, index) => (
            <MenuItem key={index} value={tag.name}>
              {tag.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default TagFilter;
